import accessMatrix from 'assets/access-matrix.png';

const AccessMatrixImage = () => (
  <img width="100%" src={accessMatrix} alt="Matrix of all the roles with corresponding access" />
);

export default AccessMatrixImage;
